import React from 'react'
import { withBasePath } from 'lib/utils'

import Video from 'components/Video/Video'
import useMarketId from 'hooks/useMarketId'
import useResponsive from 'hooks/useResponsive'

const VIDEOS = {
  au: {
    video: {
      desktop: 'desktop-bg-video-au.mp4',
      mobile: 'mobile-bg-video-au.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-au.jpg',
      mobile: 'mobile-bg-poster-au.jpg',
    },
  },
  br: {
    video: {
      desktop: 'desktop-bg-video-br.mp4',
      mobile: 'mobile-bg-video-br.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-br.jpg',
      mobile: 'mobile-bg-poster-br.jpg',
    },
  },
  ca: {
    video: {
      desktop: 'desktop-bg-video-ca.mp4',
      mobile: 'mobile-bg-video-ca.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-ca.jpg',
      mobile: 'mobile-bg-poster-ca.jpg',
    },
  },
  es: {
    video: {
      desktop: 'desktop-bg-video-es.mp4',
      mobile: 'mobile-bg-video-es.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-es.jpg',
      mobile: 'mobile-bg-poster-es.jpg',
    },
  },
  fr: {
    video: {
      desktop: 'desktop-bg-video-fr.mp4',
      mobile: 'mobile-bg-video-fr.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-fr.jpg',
      mobile: 'mobile-bg-poster-fr.jpg',
    },
  },
  gb: {
    video: {
      desktop: 'desktop-bg-video-gb.mp4',
      mobile: 'mobile-bg-video-gb.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-gb.jpg',
      mobile: 'mobile-bg-poster-gb.jpg',
    },
  },
  in: {
    video: {
      desktop: 'desktop-bg-video-in.mp4',
      mobile: 'mobile-bg-video-in.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-in.jpg',
      mobile: 'mobile-bg-poster-in.jpg',
    },
  },
  se: {
    video: {
      desktop: 'desktop-bg-video-se.mp4',
      mobile: 'mobile-bg-video-se.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-se.jpg',
      mobile: 'mobile-bg-poster-se.jpg',
    },
  },
  mx: {
    video: {
      desktop: 'desktop-bg-video-mx.mp4',
      mobile: 'mobile-bg-video-mx.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-mx.jpg',
      mobile: 'mobile-bg-poster-mx.jpg',
    },
  },
  global: {
    video: {
      desktop: 'desktop-bg-video-global.mp4',
      mobile: 'mobile-bg-video-global.mp4',
    },
    poster: {
      desktop: 'desktop-bg-poster-global.jpg',
      mobile: 'mobile-bg-poster-global.jpg',
    },
  },
}

export default function HeaderVideoStartpage() {
  const marketId = useMarketId()
  const { isMobile } = useResponsive()

  const video = VIDEOS[marketId] || VIDEOS.global

  let videoSrc = isMobile ? video.video.mobile : video.video.desktop
  let posterSrc = isMobile ? video.poster.mobile : video.poster.desktop

  try {
    videoSrc = new URL(videoSrc).toString()
    posterSrc = new URL(posterSrc).toString()
  } catch (e) {
    videoSrc = withBasePath(`/static/video/${videoSrc}`)
    posterSrc = withBasePath(`/static/img/${posterSrc}`)
  }

  // Key attr is needed to trigger re-rendering
  return (
    <Video
      id="videoBg"
      autoPlay
      muted
      loop
      playsInline
      key={videoSrc}
      poster={posterSrc}
      src={videoSrc}
    />
  )
}
